'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchPrV2Versions } from './fetch-pr-v2';
import { PR_V2_STANDARD_STALE_TIME_MS } from './query-config';
import { prV2VersionsQueryKey } from './query-keys';
export function usePrV2Versions(owner, repo, number, options) {
  const $ = _c(12);
  let t0;
  if ($[0] !== number || $[1] !== owner || $[2] !== repo) {
    t0 = prV2VersionsQueryKey(owner, repo, number);
    $[0] = number;
    $[1] = owner;
    $[2] = repo;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== number || $[5] !== owner || $[6] !== repo) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchPrV2Versions(owner, repo, number, signal);
    };
    $[4] = number;
    $[5] = owner;
    $[6] = repo;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = Boolean(owner && repo && number) && (options?.enabled ?? true);
  let t3;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: PR_V2_STANDARD_STALE_TIME_MS,
      refetchOnWindowFocus: false
    };
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return useQuery(t3);
}